import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { ServiceProxy as ResourceServiceProxy } from '@/service-proxies/app-v2/resource.service-proxies'
const resourceService = new ResourceServiceProxy()

@Component
export default class Upload extends Vue {
  @Prop() value

  fileList = []
  realFileList = []

  @Watch('realFileList')
  onListChange(val) {
    this.$emit('change', val)
  }

  beforeUpload(file: File) {
    resourceService.putFileUsingPOST({ fileName: file.name, data: file }).then(res => {
      resourceService.statFileUsingGET(res.data.name).then(el=>{
        let ossfile = el.data
        ossfile["originalName"] = res.data.originalName
        ossfile["objectKey"]=ossfile.name
        ossfile["uid"]= file["uid"]
        ossfile["name"] = file.name
        ossfile["filename"] = file.name
        this.fileList = [...this.fileList, ossfile]
        this.realFileList = [...this.realFileList, ossfile]
      })
    })
    return false
  }

  handleRemove(file) {
    const index = this.fileList.findIndex((el)=>el.uid === file.uid)
    resourceService
      .removeFileUsingPOST(this.realFileList[index].objectKey)
      .then(() => {
        const newFileList = this.fileList.slice()
        newFileList.splice(index, 1)
        this.fileList = newFileList
        const newRealFileList = this.realFileList.slice()
        newRealFileList.splice(index, 1)
        this.realFileList = newRealFileList
      })
  }

  render() {
    return (
      <a-upload fileList={this.fileList} remove={this.handleRemove} beforeUpload={this.beforeUpload}>
        <a-button>
          <a-icon type="upload" />
          {this.$t('page_dform_click_upload')}
        </a-button>
      </a-upload>
    )
  }
}
